<app-grid-container class="error-page">
  <app-grid-row class="white-container">
    <app-grid-column>
      <div class="error-page__header">
        <h1 class="error-page__header-title">Sorry, something's not right.</h1>
        <p class="error-page__header-subtitle">
          It looks like there's been a technical issue but we're working to fix
          it.
        </p>
      </div>
      <div class="error-page__footer">
        <p class="error-page__footer-intro">Still looking around?</p>
        <h2 class="error-page__footer-title">
          Here are some links that you may find useful:
        </h2>
        <ul class="error-page__footer-links">
          <li>
            <app-link
              [navigationLink]="{
                label: 'Home',
                href: 'https://www.domesticandgeneral.com',
              }"
              [newWindow]="true"
            />
          </li>
          <li>
            <app-link
              [navigationLink]="{
                label: 'Help and advice',
                href: 'https://www.domesticandgeneral.com/help-and-support',
              }"
              [newWindow]="true"
            />
          </li>
          <li>
            <app-link
              [navigationLink]="{
                label: 'Contact us',
                href: `https://${domainId}.partners.domesticandgeneral.com/register/support/contact-us`,
              }"
              [newWindow]="true"
            />
          </li>
        </ul>
      </div>
    </app-grid-column>
  </app-grid-row>
</app-grid-container>
